import React from 'react'
import { Price, wordifyfa } from '../../helpers/utility'

const PriceCard = ({ price, onClick }) => (
  <div onClick={onClick} className="recharge-card medium">
    <h3>
      <Price>{price}</Price>
    </h3>
    <span>{`${wordifyfa(price)}تومان`}</span>
    <span>شارژ اعتبار</span>
  </div>
)

export const CustomPriceCard = ({ title, onClick }) => (
  <div onClick={onClick} className="recharge-card medium">
    <h3>{title}</h3>
  </div>
)

const priceCards = [10000, 20000, 50000, 100000]

const RechargeCards = ({ onClick, children }) => (
  <section id="recharge-card-wrapper">
    {priceCards.map(price => (
      <PriceCard key={price} price={price} onClick={() => onClick(price)} />
    ))}

    {children}
  </section>
)

export default RechargeCards



// WEBPACK FOOTER //
// ./src/components/common/RechargeCards.js